import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import {
  loadBusinessOwners,
  loadBusinessOwnersFailure,
  loadBusinessOwnersSuccess
} from './business-owner.actions'
import { BusinessOwnerService } from '../../services/business-owner.service'

export const loadBusinessOwners$ = createEffect(
  (actions$ = inject(Actions), businessOwnerService = inject(BusinessOwnerService)) =>
    actions$.pipe(
      ofType(loadBusinessOwners),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          businessOwnerService.getAllBusinessOwners(action.params, action.page, action.limit).pipe(
            map(res => {
              // console.log('res', res)
              return loadBusinessOwnersSuccess({
                totalCount: res.totalCount,
                businessOwners: res.businessOwners
                // activeCount: res.activeCount,
                // inactiveCount: res.inactiveCount
              })
            }),
            catchError(error => of(loadBusinessOwnersFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const businessOwnersEffects = {
  loadBusinessOwners$
}
